import $ from 'jquery';

import { Skin } from 'lib/vendor/terrific/Application';
import { hashDeepLink } from 'lib/util/url';

import LegoContainer, { ServiceId, CurrentSelection } from '../Tc.Module.LegoContainer';
// tslint:disable-next-line: no-duplicate-imports
import type { LegoContainerConfig } from '../Tc.Module.LegoContainer';

interface DetailPagePriceOrderSkin extends LegoContainer {
	updateSelection(event : JQueryEventObject) : void;
	updateUI(data : LegoContainerConfig[]) : void;
}

// tslint:disable-next-line: variable-name
export const DetailPagePriceOrder : Skin<LegoContainer, DetailPagePriceOrderSkin> = function DetailPagePriceOrder(parent) {
	this.cacheUi = function() {
		parent.cacheUi.call(this);

		this.ui.detailContainers = this.$ctx.find('.legoDetailContainer');
		this.ui.detailContainers.toggleClass('hidden', !this.isEditMode);
		this.ui.aboSelection = this.$ctx.find('.legoDetailRadio :radio');
	};

	this.addEventListeners = function() {
		parent.addEventListeners.call(this);

		this.ui.aboSelection.on('change', this.updateSelection.bind(this));
	};

	this.handleDataSuccess = function() {
		if(this.isEditMode) {
			return;
		}

		const initConf = this.deepLinkConf;
		if(initConf && initConf.config.length) {
			this.setInitialOptions(initConf.options);
			this.initComplete = true;
			this.updateUI(initConf.config);
			this.updateSummaryUi(initConf.config);
			this.broadcastConfigurationChanged(this.currentSelection, this.calculateTotalPrice(initConf.config));
		}
	};

	this.updateUI = function(data) {
		this.ui.detailContainers.toggleClass('hidden', true);

		$.each(data.filter(Boolean), (_i, service) => {
			this.ui.detailContainers.filter(`[data-id="${service.slideId}"]`).toggleClass('hidden', false);
			this.ui.aboSelection.filter(`[value="${service.slideId}"]`).prop('checked', true);
		});
		const prices = this.calculateTotalPrice(data);
		this.$ctx.find('.detailsTotalPrice span').text(SCS.utils.formatPriceWithDash(prices.totalPrice));
		this.$ctx.find('.detailsTotalPriceTitle, .detailsTotalPrice').removeClass('hidden');

	};

	this.updateSelection = function(event) {
		const mod = this;
		const selectedSiebelId = $(event.currentTarget).val() as string;
		const selectedName = $(event.currentTarget).attr('name') as ServiceId;
		mod.broadcastConfigurationChanged(mod.currentSelection, mod.calculateTotalPrice([{slideId: selectedSiebelId, sliderId: selectedName}]));
		const deeplink = mod.serializeDeeplink(true);
		hashDeepLink.set('lpIds', deeplink, ',', false);
		const selection = Object.keys(mod.currentSelection)
			.map(key => mod.currentSelection[key as keyof CurrentSelection]!)
			.filter(Boolean);

		mod.updateUI(selection);
	};
};



// WEBPACK FOOTER //
// typescript://../clientlibs/js/lib/ecommerce/lego/skins/DetailPagePriceOrder.ts